import { render, staticRenderFns } from "./form.vue?vue&type=template&id=d0ef12b2&"
import script from "./form.vue?vue&type=script&lang=js&"
export * from "./form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0ef12b2')) {
      api.createRecord('d0ef12b2', component.options)
    } else {
      api.reload('d0ef12b2', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=d0ef12b2&", function () {
      api.rerender('d0ef12b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/workflow/components/form.vue"
export default component.exports